import Settings from "./settings.service";

const printConsole = () => {
	if (Settings["buildNumber"]) {
		console.log(
			"%c%s",
			"border-top:1px solid #e1090a;width:100%",
			"                                                    "
		);
		console.log(
			"%c%s",
			"color:#e1090a;font-weight:700;padding:5px;text-shadow:0 0 #000;font-size: 10pt",
			"Virgin Mobile"
		);
		console.log(
			"%c%s",
			"color:#e1090a;font-weight:700;padding:5px;text-shadow:0 0 #000;font-size: 8pt",
			"Emirates Integrated Telecommunications Company PJSC"
		);

		console.log(
			"%c Build No: ",
			"color: white; background-color: #2274A5",
			Settings["buildNumber"]
		);

		if (Settings["deployedAt"]) {
			console.log(
				"%c Deployed on: ",
				"color: white; background-color: #4c8613",
				Settings["deployedAt"]
			);
		}
		console.log(
			"%c%s",
			"border-bottom:1px solid #e1090a;width:100%",
			"                                                    "
		);
	}
};

export { printConsole };
